var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOpenEye(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5832 11.6C20.5639 6.91 16.7652 4 12.6666 4C8.56805 4 4.76938 6.91 2.75008 11.6C2.69504 11.7262 2.66663 11.8623 2.66663 12C2.66663 12.1377 2.69504 12.2738 2.75008 12.4C4.76938 17.09 8.56805 20 12.6666 20C16.7652 20 20.5639 17.09 22.5832 12.4C22.6382 12.2738 22.6666 12.1377 22.6666 12C22.6666 11.8623 22.6382 11.7262 22.5832 11.6ZM12.6666 18C9.48773 18 6.49878 15.71 4.76938 12C6.49878 8.29 9.48773 6 12.6666 6C15.8455 6 18.8345 8.29 20.5639 12C18.8345 15.71 15.8455 18 12.6666 18ZM12.6666 8C11.8758 8 11.1027 8.2346 10.4451 8.67412C9.78755 9.11365 9.27504 9.73836 8.97239 10.4693C8.66975 11.2002 8.59056 12.0044 8.74485 12.7804C8.89914 13.5563 9.27997 14.269 9.83918 14.8284C10.3984 15.3878 11.1109 15.7688 11.8865 15.9231C12.6622 16.0775 13.4662 15.9983 14.1968 15.6955C14.9275 15.3928 15.552 14.8801 15.9913 14.2223C16.4307 13.5645 16.6652 12.7911 16.6652 12C16.6652 10.9391 16.244 9.92172 15.4941 9.17157C14.7442 8.42143 13.7271 8 12.6666 8ZM12.6666 14C12.2712 14 11.8847 13.8827 11.5559 13.6629C11.2271 13.4432 10.9708 13.1308 10.8195 12.7654C10.6682 12.3999 10.6286 11.9978 10.7057 11.6098C10.7829 11.2219 10.9733 10.8655 11.2529 10.5858C11.5325 10.3061 11.8888 10.1156 12.2766 10.0384C12.6644 9.96126 13.0664 10.0009 13.4317 10.1522C13.7971 10.3036 14.1093 10.56 14.329 10.8889C14.5487 11.2178 14.6659 11.6044 14.6659 12C14.6659 12.5304 14.4553 13.0391 14.0803 13.4142C13.7054 13.7893 13.1969 14 12.6666 14Z",
    fill: "url(#paint0_linear_7_689)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7_689",
    x1: 10.7228,
    y1: 20,
    x2: 13.2439,
    y2: 3.7875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0073E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#44A1FF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenEye);
export default __webpack_public_path__ + "static/media/openEye.edcd666100abb8cf77b972e0361088a2.svg";
export { ForwardRef as ReactComponent };